import { useState } from 'react';

import { GetSalesInvoice, ReleaseSalesInvoice } from 'types/graphql';

import { useMutation } from '@redwoodjs/web';

import { ApolloQueryResult } from '@apollo/client';
import { showSuccessToast } from 'src/components/Toasts/toast';
import { RELEASE_SALES_INVOICE_MUTATION } from 'src/graphql/mutations/releaseSalesInvoice.mutation';
import { onError } from 'src/utils/utils';

type UseReleaseSalesInvoiceProps = {
    id: number;
    refetchSalesInvoice: (
        variables?: Partial<GraphQLOperationVariables>
    ) => Promise<ApolloQueryResult<GetSalesInvoice>>;
};

export function useReleaseSalesInvoice({ id, refetchSalesInvoice }: UseReleaseSalesInvoiceProps) {
    const [releasedSalesInvoice, setReleasedSalesInvoice] = useState<ReleaseSalesInvoice>();
    const [releaseSalesInvoice] = useMutation<ReleaseSalesInvoice>(RELEASE_SALES_INVOICE_MUTATION, {
        onCompleted: (data) => {
            showSuccessToast(`Invoice successfully resent`);
            setReleasedSalesInvoice(data);
            refetchSalesInvoice();
        },
        onError,
    });

    const handleReleaseSalesInvoice = () => {
        releaseSalesInvoice({
            variables: {
                id,
            },
        });
    };

    return {
        handleReleaseSalesInvoice,
        releasedSalesInvoice,
    };
}

export default useReleaseSalesInvoice;
